import Flex from "../../../Atomic/Flex"

import React from "react"

export default function Bold({ children }) {
  return <Flex as={`strong`}>{children}</Flex>
}
